import React from 'react';
import Profile from "../Profile";
import InfoAddress from "./InfoAddress";
import IconName from "../../../svgLogo/SvgLogo";

const Address = () => {
    return (
        <div className="address-wrapper">
            <Profile/>
            <div className="container container-address">
                <div className="address--info">
                    <InfoAddress/>
                </div>

                <div className="address--info xpt-8 xpt-lg-0">
                    <InfoAddress/>
                </div>
                <div id="hidden-address-wrapper" className="d-none">
                    <InfoAddress/>
                </div>
                <div id="parent-address-box" className="address--info--hidden">
                </div>
                <div className="new-address-button xmt-10 xmt-lg-6">
                    <div className="add-button" id="add-new-address-btn">
                        <IconName name="add_location" className="icon"/>
                        <span className="text">افزودن نشانی جدید</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Address;
